import React from 'react';
import { Link } from 'react-router-dom';

export const LojistaTermsPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto py-4 px-2 sm:px-4 pb-16 text-slate-300">
      {/* Cabeçalho direto */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-1">
          <Link
            to="/termos"
            className="text-xs text-purple-400 hover:underline flex items-center gap-1"
          >
            <i className="fas fa-arrow-left text-[10px]"></i>
            <span>Ver Termos Gerais do Cardumy</span>
          </Link>
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">
          Termos do Lojista
        </h1>
        <p className="text-xs sm:text-sm text-slate-400 mt-1">
          Versão 3.0 — vigente a partir de 17/10/2026 — contrato entre empresas, aceito na adesão ao plano.
        </p>
      </div>

      {/* Conteúdo direto */}
      <article className="space-y-6 text-sm leading-relaxed text-slate-300">
        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">1. Objeto</h2>
          <p>
            O Cardumy concede ao Lojista o direito de usar suas ferramentas de loja, estoque, pedidos, vendas presenciais, créditos e torneios, mediante pagamento de mensalidade. O Cardumy não cobra comissão sobre as vendas.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">2. Cadastro e verificação</h2>
          <p>
            O Lojista deve ter CNPJ ativo e informar os dados da empresa e do responsável. O Cardumy pode verificar essas informações e recusar ou suspender cadastros irregulares.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">3. Mensalidade</h2>
          <p>
            O valor e as condições do plano são informados no momento da adesão. Reajustes serão comunicados com 30 dias de antecedência. Em caso de inadimplência, as funções de venda poderão ser suspensas após aviso prévio.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">4. Pagamentos</h2>
          <p>
            Os pagamentos dos clientes são recebidos diretamente na conta do Lojista, por Pix ou Mercado Pago. Cabe ao Lojista conferir pagamentos e comprovantes, tratar contestações e chargebacks e arcar com as tarifas do seu provedor de pagamento.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">5. Obrigações do Lojista</h2>
          <ul className="list-disc pl-5 space-y-1 text-slate-300">
            <li>Vender apenas produtos lícitos e originais, ligados ao universo de TCG e geek;</li>
            <li>Descrever os produtos com precisão (edição, idioma, estado de conservação) e informar o preço final e o frete antes do pagamento;</li>
            <li>Manter o estoque atualizado e cumprir os prazos informados;</li>
            <li>Emitir nota fiscal e cumprir suas obrigações fiscais;</li>
            <li>Cumprir o Código de Defesa do Consumidor, inclusive arrependimento, garantia, trocas e reembolsos, e os Termos de Compras, Pagamentos e Ingressos;</li>
            <li>Responder aos clientes em até 5 dias úteis;</li>
            <li>Gerir os créditos concedidos com transparência e honrá-los;</li>
            <li>Como organizador de torneios, responder pela realização, local, segurança, regras e premiação do evento, e reembolsar os inscritos em caso de cancelamento, conforme os Termos de Compras.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">6. Responsabilidade e direito de regresso</h2>
          <p>
            O Lojista responde perante os compradores pelos produtos, ingressos e eventos que oferece. Se o Cardumy for condenado ou tiver de pagar qualquer valor por fato atribuível ao Lojista, o Lojista deverá ressarci-lo integralmente, incluindo custas e honorários.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">7. Dados pessoais de clientes</h2>
          <p>
            O Lojista é controlador dos dados que recebe para executar suas vendas e deve usá-los apenas para o pedido, a nota fiscal, o atendimento e o cumprimento de obrigações legais. Envio de marketing exige base legal própria. O Lojista deve proteger esses dados e comunicar ao Cardumy, em até 48 horas, qualquer incidente que envolva dados obtidos pela plataforma.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">8. Propriedade intelectual</h2>
          <p>
            O Lojista garante que possui os direitos sobre as fotos, textos e marcas que publicar e assume a responsabilidade por eventuais violações.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">9. Suspensão e descredenciamento</h2>
          <p>
            O Cardumy pode suspender ou descredenciar o Lojista em caso de violação destes Termos, fraude, reclamações reiteradas não resolvidas ou inadimplência. A medida será precedida de aviso, salvo em situações urgentes. Pedidos e ingressos já vendidos devem ser honrados.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">10. Prazo e rescisão</h2>
          <p>
            Este contrato vigora por prazo indeterminado. Qualquer das partes pode encerrá-lo com 30 dias de aviso prévio.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-white">11. Foro</h2>
          <p>
            Aplica-se a lei brasileira. Fica eleito o foro da sede do Cardumy.
          </p>
        </section>
      </article>

      {/* Rodapé discreto */}
      <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
        <div>
          Dúvidas sobre o credenciamento de lojas? Contate{' '}
          <a href="mailto:contato@cardumy.com" className="text-purple-400 hover:underline">
            contato@cardumy.com
          </a>.
        </div>
        <Link to="/termos" className="text-purple-400 hover:underline">
          Ver Termos de Uso e Política de Privacidade
        </Link>
      </div>
    </div>
  );
};
